/* @flow */

import { observable, runInAction } from 'mobx';

class UIStore {
    @observable isLoading: boolean;

    setIsLoading(isLoading: boolean) {
        const delay = isLoading ? 0 : 1000;

        setTimeout(() => {
            runInAction(() => {
                this.isLoading = isLoading;
            });
        }, delay);
    }
}

export default new UIStore();



// WEBPACK FOOTER //
// ./src/stores/ui-store.js